import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_my_cashback = createAsyncThunk(
    'cashback/get_my_cashback',
    async (customerId, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get('/home/cashback/me', {
                params: { clientUserId: customerId }
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Cashback məlumatı gətirilə bilmədi' }
            )
        }
    }
)

export const get_cashback_settings = createAsyncThunk(
    'cashback/get_cashback_settings',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get('/home/cashback/settings')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: 'Cashback ayarları gətirilə bilmədi' }
            )
        }
    }
)

const cashbackReducer = createSlice({
    name: 'cashback',
    initialState: {
        loader: false,
        successMessage: '',
        errorMessage: '',
        myCashback: null,
        settings: null
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearMyCashback: (state) => {
            state.myCashback = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_my_cashback.pending, (state) => {
                state.loader = true
                state.errorMessage = ''
            })
            .addCase(get_my_cashback.fulfilled, (state, { payload }) => {
                state.loader = false
                state.myCashback = payload
            })
            .addCase(get_my_cashback.rejected, (state, { payload }) => {
                state.loader = false
                state.myCashback = null
                state.errorMessage = payload?.message || 'Cashback məlumatı gətirilə bilmədi'
            })

            .addCase(get_cashback_settings.pending, (state) => {
                state.loader = true
                state.errorMessage = ''
            })
            // .addCase(get_cashback_settings.fulfilled, (state, { payload }) => {
            //     state.loader = false
            //     state.settings = payload
            // })
            .addCase(get_cashback_settings.fulfilled, (state, { payload }) => {
    state.loader = false
    state.settings = payload.settings || payload  // ← bu sətri yoxla
})
            .addCase(get_cashback_settings.rejected, (state, { payload }) => {
                state.loader = false
                state.settings = null
                state.errorMessage = payload?.message || 'Cashback ayarları gətirilə bilmədi'
            })
    }
})

export const { messageClear, clearMyCashback } = cashbackReducer.actions
export default cashbackReducer.reducer
